/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import times from 'lodash/times';

import { Grid, PageGridContainer } from '@coursera/cds-core';

import ArticleAuthorPlaceholder from 'bundles/shared-articles/components/ArticleAuthorPlaceholder';
import ArticleHubCardPlaceholder from 'bundles/shared-articles/components/hub-page/ArticleHubCardPlaceholder';

const styles = {
  pageWrapper: css`
    margin: var(--cds-spacing-400) auto;
    min-height: 50vh;
    max-width: 1022px;
  `,
};

type AuthorPageSkeletonProps = { isMobileScreen: boolean; maxArticles: number };

const AuthorPageSkeleton = ({ isMobileScreen, maxArticles }: AuthorPageSkeletonProps) => {
  return (
    <PageGridContainer css={styles.pageWrapper}>
      <Grid container spacing={isMobileScreen ? 8 : 16}>
        <Grid item xs={12}>
          <ArticleAuthorPlaceholder />
        </Grid>
        {times(maxArticles, (index) => (
          <Grid item xs={6} md={4} key={index}>
            <ArticleHubCardPlaceholder />
          </Grid>
        ))}
      </Grid>
    </PageGridContainer>
  );
};
export default React.memo(AuthorPageSkeleton);
